import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import styled from "styled-components";
import { useMemo } from "react";
import AnimatedBox from "common/animations";
import SecondRowSkeleton from "./skeletons/SecondRowSkeleton";
import Summary from "./secondRow/summary";
import ChangeSupervisor from "./secondRow/changeSupervisor";
import CreditGoldBanner from "./secondRow/creditGoldBanner";

const Card = styled.div`
  // margin:10px 10px;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  padding: 1rem 0.7rem;
  @media (min-width: 640px) {
    padding: 1.2rem 1.7rem;
  }
  display: flex;
  justify-content: space-between;
  // align-items: flex-end;
`;
const SecondRow = ({ reducerPortfolio, reducerLivePortfolio }) => {
  let reducerChangeBrokerList = useSelector(
    (state) => state.select_change_brokers_reducer,
    shallowEqual
  );

  const hasPortfolioData = useMemo(() => {
    const data = reducerLivePortfolio?.data || reducerPortfolio?.data;
    return data && Object.keys(data).length > 0;
  }, [reducerLivePortfolio?.data, reducerPortfolio?.data]);

  return (
    <div className="grid grid-cols-13 gap-6">
      <div className="col-span-13 2xl:col-span-8 tourguide-home-first-step">
        <AnimatedBox entry="slide-down">
          <CreditGoldBanner />
          {/* {reducerLivePortfolio?.loading ? (
            <Card
              style={{
                minHeight: 300,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Card>
          ) : (
            <Card>
              {Object.keys(reducerLivePortfolio?.data || reducerPortfolio?.data)
                ?.length > 0 ? (
                <Suspense fallback={<CircularProgress />}>
                  <TotalProperty
                    reducerLivePortfolio={reducerLivePortfolio}
                    reducerPortfolio={reducerPortfolio}
                    loadingReducer={loadingReducer}
                  />
                </Suspense>
              ) : (
                <Suspense fallback={<CircularProgress />}>
                  <CreditRequestHome />
                </Suspense>
              )}
            </Card>
          )} */}
        </AnimatedBox>
      </div>
      <div className="col-span-13 2xl:col-span-5 tourguide-home-second-step">
        <AnimatedBox entry="flipIn">
          <Card
            style={{
              minHeight: 510,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {hasPortfolioData ? (
              <Summary />
            ) : (
              <ChangeSupervisor
                data={reducerChangeBrokerList?.data}
                loading={reducerChangeBrokerList?.loading}
              />
            )}
          </Card>
        </AnimatedBox>
      </div>
    </div>
  );
};

export default React.memo(SecondRow);
